import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'no-expenses-placeholder',
  templateUrl: './no-expenses-placeholder.component.html',
  styleUrls: ['./no-expenses-placeholder.component.scss'],
})
export class NoExpensesPlaceholderComponent {
  @Input() text: string;
  @Input() icon: IconProp;
}
